// extracted by mini-css-extract-plugin
export default {"card":"CheckoutSummary_card__0Ri6a","text":"CheckoutSummary_text__klZ4r"};